import(/* webpackMode: "eager" */ "/codebuild/output/src2248298766/src/apps/fanychance/src/app/error.tsx");
